import { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import withRestrictedAccess from '../../higherOrderComponents/withRestrictedAccess';
import icon from '../../icons/marketing-header.svg';
import { FormattedMessage } from 'react-intl';
import MarketingResourcesWrapper from '../../components/MarketingResources';

class MarketingResources extends Component {
  render() {
    return (
      <div className='solid-container lead-list'>
        <div className='page-heading page-heading-marketing'>
          <span>
            <img src={icon} alt='' />
          </span>
          <h1>
            <FormattedMessage id='Marketing materials' />
          </h1>
        </div>
        <MarketingResourcesWrapper />
      </div>
    );
  }
}

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state) => state),
  withRestrictedAccess
);

export default enhance(MarketingResources);
